// Separate file to avoid dependency cycle.
import url from 'url';
import { selectCurrentId } from '@gandi/redux-sharing';
import { localeSelector } from '@gandi/translate';
import { pay, setPaymentCallParams } from './money';
import { submitMyCardCreation } from './mycards';
import { resource, selectCurrency } from './prepaid';
export const extractPaymentParameters = (value
// $FlowFixMe[deprecated-utility]
) => {
  const [provider, code, key] = value.split('-');
  const paymentProductId = key.split(provider)[1] || key.split(code)[1];

  // XXX: check against valid values to prevent injection ?
  return {
    provider,
    code,
    key,
    paymentProductId: paymentProductId ? parseInt(paymentProductId, 10) : undefined
  };
};
export const initRefillPrepaidOrder = (prepaidId, orderParams, options = {}) => dispatch => {
  const endPoint = `/billing/prepaids/${prepaidId}`;
  return dispatch(
  // $FlowFixMe[incompatible-variance]
  // $FlowFixMe[incompatible-call]
  resource.put(endPoint, orderParams, {
    on2XX: response => response,
    not2XX: response => Promise.reject(response),
    ...options
  }));
};
export const refillPrepaid = (params, options = {}) => async (dispatch, getState) => {
  const state = getState();
  const sharingId = options.sharingId || selectCurrentId(state);
  const paymentParameters = extractPaymentParameters(
  // $FlowFixMe[incompatible-call] because cannot do refinement correctly with  this `RefillPrepaidParamsA | RefillPrepaidParamsB` declaration
  params.creditCard || params.paymentType);

  // $FlowFixMe[prop-missing]
  if (options.savePaymentMethod && params.paymentMethodName) {
    const savePaymentMethodValues = {
      name: params.paymentMethodName,
      provider: paymentParameters.provider,
      paymentProductId: paymentParameters.paymentProductId,
      amount: params.amount
    };
    const savePaymentMethodOptions = {
      redirectTo: params.returnUrl,
      sharingId
    };
    return dispatch(submitMyCardCreation(savePaymentMethodValues, savePaymentMethodOptions));
  }
  const locale = localeSelector(state);
  const currency = selectCurrency(state, {
    sharingId
  });
  if (!currency) {
    return Promise.reject(new Error(`No currency for prepaid ${sharingId}`));
  }
  let baseUrl = url.parse(params.returnUrl);
  let returnUrl = url.format({
    ...baseUrl,
    query: {
      // $FlowFixMe[not-an-object] but yeah it is
      ...baseUrl.query,
      order: params.orderId
    }
  });
  let orderId = params.orderId;
  if (!params.orderId) {
    try {
      const initRefillResponse = await dispatch(initRefillPrepaidOrder(sharingId, {
        amount: params.amount,
        currency
      }));
      const {
        session_id
      } = initRefillResponse.data;
      orderId = session_id;
      baseUrl = url.parse(params.returnUrl);
      returnUrl = url.format({
        ...baseUrl,
        query: {
          // $FlowFixMe[not-an-object] but yeah it is
          ...baseUrl.query,
          order: orderId
        }
      });
    } catch (err) {
      return Promise.reject(new Error(`Cannot init refill prepaid ${sharingId}`));
    }
  }
  return dispatch(pay({
    orderId,
    locale,
    ...paymentParameters,
    payUrl: params.payUrl,
    saveUrl: params.saveUrl,
    returnUrl
  }, {
    sharingId
  })).then(({
    data
  }) => dispatch(setPaymentCallParams(data))).catch(() => Promise.reject(new Error(`Cannot refill prepaid ${sharingId}`)));
};